exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-margin[data-v-659df4aa] {\n  margin: 0;\n}\n.filters[data-v-659df4aa] {\n  display: inline-block;\n  margin: 1rem 0 0 1rem;\n}\ntable th.compact[data-v-659df4aa], table td.compact[data-v-659df4aa] {\n  white-space: nowrap;\n  width: 1px !important;\n}\ntable tbody tr.loading[data-v-659df4aa] {\n  opacity: .5;\n}\n.no-mail-today[data-v-659df4aa] {\n  padding: 0 10px 15px;\n}\n.small-margin-left[data-v-659df4aa] {\n  margin-left: 0.5em;\n}\n", ""]);

// exports
